export const Screen = {
  unknown: 0,
  login: 1,
  landingpage: 2,
  userlist: 3,
  userdetail: 4,
  loanproductlist: 5,
  loanproductdetail: 6,
  customerlist: 7,
  customerdetail: 8,
  loanaccountdetail: 9,
  loanrepaymentdetail: 10,
  loanchargecreation: 11,
  journalentry: 12,
  userreport: 13,
  loanaccountstatuswisereport: 14,
  generalledgerlist: 15,
  generalledgerdetail: 16,
  loaninterestlist: 17,
  loaninterestdetail: 18,
  loanschemelist: 19,
  loanschemedetail: 20,
  quickid: 21,
  createbatch: 22,
  linkedcustomer: 23,
  casaschemelist: 24,
  casaschemedetail: 25,
  casaaccountlist: 26,
  casaaccountdetail: 27,
  shareschemelist: 28,
  shareschemedetail: 29,
  shareaccountlist: 30,
  shareaccountdetail: 31,
  quickloan: 32,
  loandue: 33,
  accountstatement: 34,
  loanaccountlist: 35,
  loanaccountcharges: 36,
  termdepositschemelist: 37,
  termdepositschemedetail: 38,
  overdraftschemelist: 39,
  overdraftschemedetail: 40,
  termdepositinterestlist: 41,
  termdepositinterestdetail: 42,
  overdraftaccountlist: 43,
  overdraftaccountdetail: 44,
  clearingschemelist: 46,
  clearingschemedetail: 47,
  outwarddataentry: 48,
  outwardreconciliation: 49,
  termdepositaccountlist: 50,
  termdepositaccountdetail: 51,
  commissioninterestlist: 52,
  commissioninterestdetail: 53,
  tdsratelist: 54,
  tdsratedetail: 55,
  pigmyschemelist: 56,
  pigmyschemedetail: 57,
  pigmyinterestlist: 58,
  pigmyinterestdetail: 59,
  pigmyaccountlist: 60,
  pigmyaccountdetail: 61,
  depositloanaccount: 62,
  pigmyaccountcollection: 63,
  generalledgeraccountlist: 64,
  generalledgeraccountdetail: 65,
  appraiserlist: 66,
  appraiserdetail: 67,
  recurringdepositschemelist: 68,
  recurringdepositschemedetail: 69,
  recurringdepositinterestlist: 70,
  recurringdepositinterestdetail: 71,
  recurringdepositaccountlist: 72,
  recurringdepositaccountdetail: 73,
  pigmyaccountwithdrawalandclosure: 74,
  pigmyaccountexport: 75,
  pigmyaccountimport: 76,
  recurringdepositcollection: 77,
  agmattendance: 78,
  agmvoterslists: 79,
  microfinancecenterlist: 80,
  microfinancecentedetail: 81,
  banknpaparameterlist: 82,
  banknpaparameterdetail: 83,
  productlevelnpalist: 84,
  productlevelnpadetail: 85,

  authorisationmaintenance: 1000,
  authorisationtransaction: 1001,

  transactiondetail: 1501,
  transfertransaction: 1502,
  cashtransaction: 1503,
  cashiertransactionlist: 1504,
  cashwithdrawalform: 1505,
  trusttransaction: 104,
  reportsdashboard: 2000,
  testreport: 2001,
  restreport: 2002,
  cashscrollreport: 2003,
  transferscrollreport: 2004,
  subdaybookreport: 2005,
  daybook1report: 2006,
  daybook2report: 2007,
  balancesheetreport: 2008,
  profitandlossreport: 2009,
  schedulereport: 2011,
  schedulewithreceiptsandpaymentsreport: 2030,
  graph: 2032,
  dcbreport: 2019,
  trialbalancereport: 2010,
  previousdaysloanrecoveryreport: 2020,
  loanaccountsduereport: 2025,
  currencylist: 88,
  currencydetails: 89,
  currencyexchangeratelist: 90,
  currencyexchangedetail: 91,
  customerreport: 2038,
  openedshareaccountsreport: 2039,
  recurringdepositreport: 2040,
  mpesalist: 92,
  termdepositreport: 2043,
  mpesareport: 2041,
  smsreport: 2042,
  customersharereport: 2044,
  changepassword: 103,
  deletetransactionreport: 2045,
  socialcontributionreport: 2046,
  monthendpenaltyreport: 2047,
  casainterestdetails: 2048,
  monthendloanrepaymentreport: 2049,
  loanaccountstatement: 2050,
  loancalculator: 105,
  loanaccountsduebucketwisereport: 2051,
  otherreceivable: 2052,
  calculatedividend: 108,
  dividendpayment: 109,
  accountstatus: 110,
  accountstatusdetailsreport: 2051,
  lienreport: 2054,
  loanoverduerelease: 111,
  sharedividendreport: 2053,
  provisionpayment: 112,
  accrualloaninterestreport: 2055,
  accrualsavingsinterestreport: 2056,
  productwiseaccountdetails: 2057,
  monthendnetbalance: 2058,
  auditlog: 2059,
  userhistoryreport: 2060,
  loanPaymentReport: 2061,
  interfacetransactionreport: 2064,
  BranchMasterDetails: 1514,
  cashiercashgllist: 2070,
  cashiercashgldetail: 2071,
  monthendwisereport: 2077,
  erpreport: 2078,
  deletetransaction: 2079,
  deleteaccounts: 2080,
  deleteaccountsreport: 2081,
  screen: 2082,
  role: 2083,
  rolescreenList: 2084,
  roleScreenDetail: 2085,
  dashboard: 2086,
  reportmaster: 2089,
  // reportgroup:2091,
  reportsubgroup: 2093,
  assigngluubgroup: 2095,
  reportclassification: 2097,
  reportdefinition: 2099,
  sharedividend: 2101,
  dataupload: 2091,
  userdetails: 2102,
  sharedividendcalculate: 2103,
  transactionupload: 2104,
  transfer: 2105,
  applicationreq: 2106,
  // interfacekycreq:2107,
  deleteupload: 2108,
  //  agmattendancereport:2109,
  yearendreport: 2074,
  provisionreport: 2073,
  loantransfer: 2075,
  banktenantlist: 2107,
  banktenantdetails: 2111,
  unionlist: 2109,
  uniondetails: 2110,
  loanaccountreport: 2112,
  unionlistss: 2113,
  uniondetailss: 2114,
  userbranchrole: 2115,
  specialloanauthorisation: 2116,
  company: 2117,
  financialdashboard: 2118,
  fcb: 2119,
  maturityprofile: 2237,
  schedulegenderdistribution: 2234,
  chargeList: 2159,
  chargeDetail: 2160,
  Invoice: 2238,
  InvoiceList: 2139,
  InvoiceDetail:2156,
  organizationbilllist: 2132,
  organizationbilldetail: 2133,
  TransactionTypeList: 2142,
  TransactionTypeDetail: 2143,
  TransactionCodeWiseChargesList: 2146,
  TransactionCodeWiseChargesDetails: 2147,
    EwalletSourceChannelList: 2144,
  EwalletSourceChannelDetail: 2145,
  invoicebillingreport: 2251,
  EwalletRestrictionList: 2150,
  EwalletRestriction: 2151,
  AccountClassRestrictionList: 2148,
  AccountClassRestrictionDetail: 2149,
  InterfaceAccountChargesList:2152,
InterfaceAccountChargesDetail:2153,
standinginstructionlist:2181,
standinginstructiondetail:2182,
DataSecurityList:2194,
DataSecurityDetail:2195

  
};

export const ScreenMap = {
  "0": "unknown",
  "1": "login",
  "2": "landingpage",
  "3": "userlist",
  "4": "userdetail",
  "5": "loanproductlist",
  "6": "loanproductdetail",
  "7": "customerlist",
  "8": "customerdetail",
  "9": "loanaccountdetail",
  "10": "loanrepaymentdetail",
  "11": "loanchargecreation",
  "12": "journalentry",
  "13": "userreport",
  "14": "loanaccountstatuswisereport",
  "15": "generalledgerlist",
  "16": "generalledgerdetail",
  "17": "loaninterestlist",
  "18": "loaninterestdetail",
  "19": "loanschemelist",
  "20": "loanschemedetail",
  "21": "quickid",
  "22": "createbatch",
  "23": "linkedcustomer",
  "24": "casaschemelist",
  "25": "casaschemedetail",
  "26": "casaaccountlist",
  "27": "casaaccountdetail",
  "28": "shareschemelist",
  "29": "shareschemedetail",
  "30": "shareaccountlist",
  "31": "shareaccountdetail",
  "32": "quickloan",
  "33": "loandue",
  "34": "accountstatement",
  "35": "loanaccountlist",
  "36": "loanaccountcharges",
  "37": "termdepositschemelist",
  "38": "termdepositschemedetail",
  "39": "overdraftschemelist",
  "40": "overdraftschemedetail",
  "41": "termdepositinterestlist",
  "42": "termdepositinterestdetail",
  "43": "overdraftaccountlist",
  "44": "overdraftaccountdetail",
  "46": "clearingschemelist",
  "47": "clearingschemedetail",
  "48": "outwarddataentry",
  "49": "outwardreconciliation",
  "50": "termdepositaccountlist",
  "51": "termdepositaccountdetail",
  "52": "commissioninterestlist",
  "53": "commissioninterestdetail",
  "54": "tdsratelist",
  "55": "tdsratedetail",
  "56": "pigmyschemelist",
  "57": "pigmyschemedetail",
  "58": "pigmyinterestlist",
  "59": "pigmyinterestdetail",
  "60": "pigmyaccountlist",
  "61": "pigmyaccountdetail",
  "62": "depositloanaccount",
  "63": "pigmyaccountcollection",
  "64": "generalledgeraccountlist",
  "65": "generalledgeraccountdetail",
  "66": "appraiserlist",
  "67": "appraiserdetail",
  "68": "recurringdepositschemelist",
  "69": "recurringdepositschemedetail",
  "70": "recurringdepositinterestlist",
  "71": "recurringdepositinterestdetail",
  "72": "recurringdepositaccountlist",
  "73": "recurringdepositaccountdetail",
  "74": "pigmyaccountwithdrawalandclosure",
  "75": "pigmyaccountexport",
  "76": "pigmyaccountimport",
  "77": "recurringdepositcollection",
  "78": "agmattendance",
  "79": "agmvoterslists",
  "80": "microfinancecenterlist",
  "81": "microfinancecentedetail",
  "82": "banknpaparameterlist",
  "83": "banknpaparameterdetail",
  "84": "productlevelnpalist",
  "85": "productlevelnpadetail",
  "103": "changepassword",
  "1000": "authorisationmaintenance",
  "1001": "authorisationtransaction",

  "1501": "transactiondetail",
  "1502": "transfertransaction",
  "1503": "cashtransaction",
  "1504": "cashiertransactionlist",
  "1505": "cashwithdrawalform",

  "2000": "reportsdashboard",
  "2001": "testreport",
  "2002": "restreport",
  "2003": "cashscrollreport",
  "2004": "transferscrollreport",
  "2005": "subdaybookreport",
  "2006": "daybook1report",
  "2007": "daybook2report",
  "2008": "balancesheetreport",
  "2009": "profitandlossreport",
  "2011": "schedulereport",
  "2030": "schedulewithreceiptsandpaymentsreport",
  "2032": "graph",
  "2019": "dcbreport",
  "2010": "trialbalancereport",
  "2020": "previousdaysloanrecoveryreport",
  "2025": "loanaccountsduereport",
  "88": "currencylist",
  "89": "currencydetails",
  "90": "currencyexchangeratelist",
  "91": "currencyexchangedetail",
  "2038": "customerreport",
  "2039": "openedshareaccountsreport",
  "2040": "recurringdepositreport",
  "92": "mpesalist",
  "2043": "termdepositreport",
  "2041": "mpesareport",
  "2042": "smsreport",
  "2044": "customersharereport",
  "2045": "deletetransactionreport",
  "2046": "socialcontributionreport",
  "2047": "monthendpenaltyreport",
  "2048": "casainterestdetails",
  "2049": "monthendloanrepaymentreport",
  "2050": "loanaccountstatement",
  "104": "trusttransaction",
  "105": "loancalculator",
  "106": "loanaccountsduebucketwisereport",
  "2052": "otherreceivable",
  "108": "calculatedividend",
  "109": "dividendpayment",
  "110": "accountstatus",
  "2051": "accountstatusdetailsreport",
  "2054": "lienreport",
  "111": "loanoverduerelease",
  "2053": "sharedividendreport",
  "112": "provisionpayment",
  "2055": "accrualloaninterestreport",
  "2056": "accrualsavingsinterestreport",
  "2057": "productwiseaccountdetails",
  "2058": "monthendnetbalance",
  "2059": "auditlog",
  "2060": "userhistoryreport",
  "2061": "loanPaymentReport",
  "2064": "interfacetransactionreport",
  "1514": "BranchMasterDetails",
  "2070": "cashiercashgllist",
  "2071": "cashiercashgldetail",
  "2077": "monthendwisereport",
  "2078": "erpreport",
  "2079": "deletetransaction",
  "2080": "deleteaccounts",
  "2081": "deleteaccountsreport",
  "2082": "screen",
  "2083": "role",
  "2084": "roleScreenList",
  "2085": "roleScreenDetail",
  "2086": "dashboard",
  "2088": "dataupload",
  "2089": "reportmaster",
  //"2091":"reportgroup",
  "2093": "reportsubgroup",
  "2095": "assigngluubgroup",
  "2097": "reportclassification",
  "2099": "reportdefinition",
  "2101": "sharedividend",
  "2091": "dataupload",
  "2102": "userdetails",
  "2103": "sharedividendcalculate",
  "2104": "transactionupload",
  "2105": "transfer",
  "2106": "applicationreq",
  // "2107":"interfacekycreq",
  "2108": "deleteupload",
  //  "2109":"agmattendancereport",
  "2074": "yearendreport",
  "2073": "provisionreport",
  "2107": "banktenantlist",
  "2111": "banktenantdetails",
  "2109": "unionlist",
  "2110": "uniondetails",
  "2112": "loanaccountreport",
  "2113": "unionlistss",
  "2114": "uniondetailss",
  "2116": "specialloanauthorisation",
  "2115": "userbranchrole",
  "2117": "company",
  "2118": "financialdashboard",
  "2119": "fcb",
  "2237": "maturityprofile",
  "2234": "schedulegenderdistribution",
  "2159": "chargeList",
  "2160": "chargeDetail",
  "2238": "Invoice",
  "2139": "InvoiceList",
  "2156":"InvoiceDetail",
  "2132": "organizationbilllist",
  "2133": "organizationbilldetail",
    "2142":"TransactionTypeList",
  "2143": "TransactionTypeDetail",
'2146':"TransactionCodeWiseChargesList",
  '2147': "TransactionCodeWiseChargesDetails",
'2144':'EwalletSourceChannelList',
'2145':'EwalletSourceChannelDetail',
"2251":"invoicebillingreport",
"2150":"EwalletRestrictionList",
  "2151": "EwalletRestriction",
 "2148": "AccountClassRestrictionList",
  "2149": "AccountClassRestrictionDetail",
  '2256': "InterfaceAccountChargesDetail",
  "2153":"interfaceaccountchargesdetail",
  "2152":"InterfaceAccountChargesList",
  "2181":"standinginstructionlist",
  "2182":"standinginstructiondetail",
  "2194":"DataSecurityList",
  "2195":"DataSecurityDetail"

};

export const ScreenAction = {
  Unknown: 0,
  View: 1,
  Create: 2,
  Update: 4,
  Delete: 8,
  Authorise: 16,
};
